import moment from 'moment';

import {
	changeReservationStep,
	getReservationTime,
	clearReservationTime,
	initReservationFormData,
	setReservationFormData,
	getReservationDate,
} from 'actions/reservation';
import { getRoomById } from 'actions/room';
import { closeAlert } from 'actions/alert';

import { withAsyncEnterLoader, withAsyncChangeLoader, withLoader } from 'util/routeHelper';
import { languageMapRoute } from 'util/i18n';
import { serverMapEmpty } from 'util/helper';
import AllCountries from 'util/country';

export default store => ({
	path: 'reservation',
	indexRoute: {
		getComponent: withLoader(
			(nextState, cb) =>
				require.ensure(
					[],
					require => {
						const component = require('./component').default;
						cb(null, component);
					},
					'RoomReservation',
				),
			store,
			'RoomReservation',
		),
	},
	onEnter: withAsyncEnterLoader(
		async (
			{ params: { id }, location: { query: { step = 'reservation' } } },
			replace,
			updateRatio,
		) => {
			const { reservation: { canAccess }, i18n: { lan } } = store.getState();

			if (!canAccess) {
				replace(`/${languageMapRoute(lan)}/room/${id}`);
				return;
			}
			store.dispatch(closeAlert('reserve'));

			store.dispatch(changeReservationStep(step));
			updateRatio(0.8);

			// Auto setup reservation form data
			store.dispatch(initReservationFormData());

			const { user: { data } } = store.getState();

			store.dispatch(
				setReservationFormData(
					{
						value: serverMapEmpty(data.phone),
						country: AllCountries.getCountryByCode(data.phoneCountry),
					},
					{ value: serverMapEmpty(data.hangout) },
				),
			);

			// Setup reservation time
			store.dispatch(clearReservationTime());
			const today = moment()
				.add(1, 'day')
				.hour(8)
				.minute(0)
				.second(0)
				.format('YYYY-MM-DD HH:mm:ss');

			await Promise.all([
				store.dispatch(getRoomById(id)),
				store.dispatch(getReservationTime(today, id, 'MORNING')),
				store.dispatch(getReservationTime(today, id, 'AFTERNOON')),
				store.dispatch(getReservationDate(today, id)),
			]);
		},
		store,
		'ENTER_ROOM_RESERVATION',
	),
	onChange: withAsyncChangeLoader(
		async (
			_,
			{ params: { id }, location: { query: { step = 'reservation' } } },
			replace,
			updateRatio,
		) => {
			store.dispatch(closeAlert('reserve'));
			store.dispatch(changeReservationStep(step));
			updateRatio(0.8);

			if (step === 'reservation') {
				const { reservation: { canAccess }, i18n: { lan } } = store.getState();

				if (!canAccess) {
					replace(`/${languageMapRoute(lan)}/room/${id}`);
					return;
				}

				store.dispatch(clearReservationTime());
				const today = moment()
					.add(1, 'day')
					.hour(8)
					.minute(0)
					.second(0)
					.format('YYYY-MM-DD HH:mm:ss');
				await Promise.all([
					store.dispatch(getRoomById(id)),
					store.dispatch(getReservationTime(today, id, 'MORNING')),
					store.dispatch(getReservationTime(today, id, 'AFTERNOON')),
					store.dispatch(getReservationDate(today, id)),
				]);
			}
		},
		store,
		'CHANGE_ROOM_RESERVATION',
	),
});



// WEBPACK FOOTER //
// ./src/routes/Room/Reservation/index.js